import { render, staticRenderFns } from "./PageSubHeader.vue?vue&type=template&id=69dfdbf7&scoped=true&"
import script from "./PageSubHeader.vue?vue&type=script&setup=true&lang=js&"
export * from "./PageSubHeader.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PageSubHeader.vue?vue&type=style&index=0&id=69dfdbf7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69dfdbf7",
  null
  
)

export default component.exports